/* @flow */
import React from 'react';
// $FlowIgnore
import { FaFlask } from 'react-icons/fa';

export default function BiospecimenIcon({
  style
}: Object): React.Element {
  return <FaFlask style={{color: 'forestgreen', ...style}} />;
}
